import { render, staticRenderFns } from "./CompanyPayments.vue?vue&type=template&id=18330916&scoped=true&"
import script from "./CompanyPayments.vue?vue&type=script&lang=js&"
export * from "./CompanyPayments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPayments.vue?vue&type=style&index=0&id=18330916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18330916",
  null
  
)

export default component.exports